export const MerchantSelectionConfirmDialogViewStyles = {
  title: 'text-blue500 text-24px font-semibold',
  address: 'mt-6 mb-8 w-auto text-gray',
  buttonsContainer: 'flex flex-col-reverse justify-center sm:flex-row',
  closeButton: 'mt-6 sm:mr-12 ',
}
